export const styleConfig = {
  screenPadding: {
    mobile: "25px",
    desktop: null,
  },
  color: {
    primary: "#5b1eeb",
    adjustPrimary: "#5b1eeb",
    semiPrimary: "rgba(255, 255, 255, 0.25)",
    secondary: "#F0F2F4",
    white: "#FFF",
    text: "#243442",
    textSecondary: "#8F9AA3",
    success: "#2e7d32",
    error: "#d32f2f",
    headerText: {
      firstText: {
        primary: "#A6CFF2",
        secondary: "#8F9AA3",
      },
      outstandingText: {
        primary: "#FFF",
        secondary: "#243442",
      },
    },
  },
};
